var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabletChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.549,
    height: 129.52
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tablet-checked_svg__a",
    x: 16.291,
    y: 0,
    width: 119.588,
    height: 129.52,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#657a93",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tablet-checked_svg__b",
    x: 9.529,
    y: 0.08,
    width: 126.265,
    height: 125.86,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#657a93",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tablet-checked_svg__d",
    x: 75.252,
    y: 21.4,
    width: 57.631,
    height: 57.81,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1d4bff",
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tablet-checked_svg__c",
    x1: 0.002,
    y1: 0.493,
    x2: 1.009,
    y2: 0.493,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff66a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f53689"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 43
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M118.59 55.47a42.841 42.841 0 01-8.577 25.7 43.4 43.4 0 01-10.616 9.9 41.718 41.718 0 01-23.015 6.92 42.435 42.435 0 1123.015-78.04 43.4 43.4 0 0110.616 9.9 41.884 41.884 0 018.577 25.62z",
    fill: "#eaeef9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M103.134 17.3a2.377 2.377 0 012.377 2.39v70.79a2.38 2.38 0 01-2.378 2.39H50.989a2.383 2.383 0 01-2.378-2.39V19.69a2.381 2.381 0 012.378-2.39z",
    fill: "#ced7e2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M105.512 24.73v65.66a2.38 2.38 0 01-2.378 2.39H55.49l-4.161-4.18 47.3-65.07 4.08-1.53z",
    fill: "#bcc4cf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M103.304 23.19h-51.55v65.75a.851.851 0 00.849.85h50.7z",
    fill: "#a6afba"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M102.879 22.76a.761.761 0 00-.764-.76H52.093a.761.761 0 00-.764.76v64.98a.763.763 0 00.764.77h49.936a.763.763 0 00.764-.77V22.76z",
    fill: "#dfe7f0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .002)",
    filter: "url(#tablet-checked_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M102.878 22.76a.761.761 0 00-.764-.76H52.09c-.424 0-.849.34-.764.76.596 25.88.851 55.16-2.036 62.76l47.9-.68c2.97-13.15 5.178-36.8 5.688-62.08z",
    fill: "#eaebf5"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .002)",
    filter: "url(#tablet-checked_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M102.795 22.08s-.085 3.93-1.274 28.78v.51c-1.444 24.42-23.1 29.54-25.732 29.8-1.189.08-3.482.25-7.644.34-5.095.17-12.908.26-25.053.43a.544.544 0 01-.509-.77c8.492-16.99 8.577-59 8.577-59h51.635z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M90.904 65.97H66.191c-.17 0-.34-.26-.34-.68 0-.34.17-.69.34-.69h24.8c.17 0 .34.26.34.69-.002.34-.172.68-.427.68z",
    fill: "#ced7e2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M78.251 69.81h-12.23c-.17 0-.339-.25-.339-.68 0-.34.169-.68.339-.68h12.23c.169 0 .339.25.339.68 0 .34-.17.68-.339.68z",
    fill: "#e3eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M94.896 34.72H70.098c-.17 0-.34-.26-.34-.68 0-.35.17-.69.34-.69h24.8c.17 0 .34.26.34.69s-.172.68-.342.68zM94.726 38.56h-9.851c-.17 0-.34-.26-.34-.68 0-.34.17-.69.34-.69h9.851c.17 0 .34.26.34.69s-.17.68-.34.68z",
    fill: "#ced7e2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M82.157 38.56H69.928c-.17 0-.34-.26-.34-.68 0-.34.17-.69.34-.69h12.229c.17 0 .34.26.34.69s-.17.68-.34.68z",
    fill: "#e3eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M101.435 51.28c-1.443 24.42-23.1 29.55-25.732 29.8-1.189.09-3.482.26-7.644.34 10.786-5.03 16.561-14 16.476-21 5.265.43 14.268 0 16.9-9.14z",
    fill: "#eaeef9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M59.907 38.82a.743.743 0 01-.51-.26l-2.463-2.39a.776.776 0 010-1.02.763.763 0 011.019 0l1.954 1.955 3.991-4.005a.763.763 0 011.019 0 .776.776 0 010 1.02l-4.5 4.53a1.283 1.283 0 01-.51.17z",
    fill: "#3772ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M93.792 50H68.994c-.17 0-.34-.25-.34-.68 0-.34.17-.68.34-.68h24.8c.17 0 .34.25.34.68-.002.34-.172.68-.342.68z",
    fill: "#ced7e2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M81.053 53.84H68.824c-.17 0-.34-.25-.34-.68 0-.34.17-.68.34-.68h12.229c.17 0 .34.25.34.68.085.34-.085.68-.34.68z",
    fill: "#e3eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M58.802 54.1a.727.727 0 01-.509-.25l-2.378-2.4a.776.776 0 010-1.02.763.763 0 011.019 0l1.953 1.955 3.992-4.005a.763.763 0 011.019 0 .776.776 0 010 1.02l-4.586 4.45a.511.511 0 01-.51.25z",
    fill: "#3772ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M89.206 17.47l-.51-.51a1.189 1.189 0 00-.424.25h-7.728v-.51a2.973 2.973 0 10-5.945 0 .659.659 0 00.083.43h-8.151a.851.851 0 00-.849.85v2.65a3.043 3.043 0 003.312 3.16h16.645c1.953 0 3.737-1.2 3.737-3.16v-2.65c.085-.17 0-.34-.17-.51z",
    fill: "#1c3754"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M88.951 17.47v3.16a3.562 3.562 0 01-3.482 3.07h-16.73a3.562 3.562 0 01-3.482-3.07v-3.16a.848.848 0 01.849-.85h8.151v-.43a2.973 2.973 0 115.945 0v.43h8.155a.944.944 0 01.594.85z",
    fill: "#2d5887"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M77.062 17.56a1.37 1.37 0 10-1.359-1.37 1.369 1.369 0 001.359 1.37z",
    fill: "#eaeef9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M88.866 20.63a3.561 3.561 0 01-3.482 3.07H68.739a3.562 3.562 0 01-3.482-3.07z",
    fill: "#316094"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M82.417 19.43H71.541a.4.4 0 01-.424-.425.4.4 0 01.424-.425h10.876a.4.4 0 01.424.43.4.4 0 01-.424.42z",
    fill: "#1c3754",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M10.276 44.986s-8.408 2.13-5.86 3.84c2.548 1.62 8.578 4.44 14.268 2.56s0-4.53.085-4.53-8.493-1.87-8.493-1.87z",
    fill: "#ced7e2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M0 44.296c3.057.94 12.484-.6 18.514-4.52 4.756 5.89 6.539 7.43 8.238 7.6-2.633 2.64-11.38 6.91-16.306 1.36C4.671 52.406 0 44.296 0 44.296zM120.882 74.34c3.227.17 11.975-3.76 16.731-9.05 6.114 4.52 8.152 5.55 9.936 5.29-1.953 3.24-7.9 10.33-16.306 10.84a87.5 87.5 0 01-10.361-7.08z",
    fill: "#dfe7f0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M2.038 4.1A2.05 2.05 0 100 2.05 2.046 2.046 0 002.038 4.1z",
    transform: "translate(56.425 64.86)",
    fill: "url(#tablet-checked_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M105.511 26.27h-3.481v2.3h3.481zM92.28 30.85l-1.922 1.93 1.381 1.39 1.919-1.93zM114.469 32.08l1.921 1.93 1.261-1.27-1.921-1.93z",
    fill: "#526dff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .002)",
    filter: "url(#tablet-checked_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M104.066 62.21a16.905 16.905 0 10-16.816-16.9 16.86 16.86 0 0016.816 16.9z",
    fill: "#3772ff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M104.153 60.93a15.825 15.825 0 01-4.926-.77.756.756 0 01.425-1.45 12.973 12.973 0 004.416.692 14.213 14.213 0 0014.013-12.392.7.7 0 01.849-.59.7.7 0 01.594.85 15.708 15.708 0 01-5.18 9.73 14.9 14.9 0 01-10.191 3.93z",
    fill: "#526dff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M117.319 45.309a13.253 13.253 0 01-26.5 0 13.328 13.328 0 0113.249-12.9 13.161 13.161 0 0113.251 12.9z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M115.363 45.82h-2.124a.585.585 0 01-.594-.6.585.585 0 01.594-.6h2.124a.585.585 0 01.594.6.585.585 0 01-.594.6zM94.301 45.82h-2.123a.585.585 0 01-.594-.6.585.585 0 01.594-.6h2.123a.585.585 0 01.6.6.585.585 0 01-.6.6zM103.728 57.52a.584.584 0 01-.594-.6v-2.14a.576.576 0 01.594-.59.577.577 0 01.6.59v2.14a.585.585 0 01-.6.6zM103.728 36.34a.584.584 0 01-.594-.6v-2.13a.584.584 0 01.594-.6.585.585 0 01.6.6v2.13a.585.585 0 01-.6.6zM103.898 46.93a1.965 1.965 0 10-1.953-1.97 1.96 1.96 0 001.953 1.97z",
    fill: "#dae1ed"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M111.714 36.6a.639.639 0 00-.849 0l-6.967 7.337h-.084a.947.947 0 00-.934.94v.08l-1.1 1.2a.646.646 0 000 .85.624.624 0 00.424.17.625.625 0 00.425-.17l1.1-1.19h.085a.947.947 0 00.934-.94v-.17l6.966-7.337a.482.482 0 000-.77z",
    fill: "#eb358a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M111.541 36.849l-9.426 9.911h-.17c-.085-.09-.085-.26.085-.43l9.087-9.561a.24.24 0 01.424 0z",
    fill: "#ff4fa2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M107.21 23.02v2.22a1.531 1.531 0 01-1.529 1.54h-3.736a1.531 1.531 0 01-1.529-1.54v-2.22a1.531 1.531 0 011.529-1.54h3.736a1.531 1.531 0 011.529 1.54zM92.603 31.05l-2.038 2.05a1.3 1.3 0 01-1.7 0l-1.188-1.2a1.3 1.3 0 010-1.71l2.038-2.05a1.3 1.3 0 011.7 0l1.189 1.2a1.307 1.307 0 01-.001 1.71zM115.363 31.05l2.038 2.05a1.3 1.3 0 001.7 0l1.189-1.2a1.307 1.307 0 000-1.71l-2.04-2.05a1.3 1.3 0 00-1.7 0l-1.187 1.2a1.305 1.305 0 000 1.71z",
    fill: "#172d45"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M103.898 45.14a.175.175 0 00.17-.175.17.17 0 10-.34 0 .175.175 0 00.17.175z",
    fill: "#1c3754"
  }))));
}
export default SvgTabletChecked;